import Vue from "vue";
import App from "./App.vue";
import vuetify from './plugins/vuetify'
import router from "./router";
import store from "./store";
import VueRx from "vue-rx";
import {
  dateFormat,
  dateParse,
  dateParseISO,
  dateParseJSON,
  json,
  boolFormat,
  byteFormat,
  moneyFormat
} from "./filters";
import $api from "./services/api.service";
import $device from './services/device-detector.service';
import "./main.scss";

Vue.config.productionTip = false;

Vue.use(VueRx);

Vue.filter("dateParse", dateParse);
Vue.filter("dateFormat", dateFormat);
Vue.filter("dateParseISO", dateParseISO);
Vue.filter("dateParseJSON", dateParseJSON);
Vue.filter("json", json);
Vue.filter("boolFormat", boolFormat);
Vue.filter("byteFormat", byteFormat);
Vue.filter("currency", moneyFormat);

new Vue({
  router,
  store,
  vuetify,
  provide: {
    $api: $api,
    $device: $device
  },
  render: h => h(App)
}).$mount("#app");
